import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card } from "../components/ui/card";
import { Lock, Radar } from "lucide-react";
import { toast } from "sonner";
import { login } from "../lib/api";

const LOGIN_BG =
  "https://static.prod-images.emergentagent.com/jobs/4a0758f5-cb62-43b9-85ce-1d19ad38091d/images/e27c8738e20d40286005a31394b2cb3f92b792f7eec42531ed6e503ea11b6dac.png";

export default function Login() {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!password) return;
    setLoading(true);
    try {
      await login(password);
      toast.success("Erişim onaylandı", { description: "Panele yönlendiriliyorsunuz" });
      navigate("/dashboard", { replace: true });
    } catch (err) {
      toast.error("Şifre hatalı", { description: "Lütfen tekrar deneyin" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen w-full relative flex items-center justify-center"
      style={{
        backgroundImage: `linear-gradient(rgba(10,10,10,0.85), rgba(10,10,10,0.92)), url(${LOGIN_BG})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
      data-testid="login-page"
    >
      <div className="absolute inset-0 tactical-grid pointer-events-none opacity-50" />
      <Card className="relative w-[420px] max-w-[92vw] bg-[#0F0F10]/95 backdrop-blur border-white/10 rounded-sm p-7">
        <div className="flex items-center gap-2 mb-6">
          <div className="h-9 w-9 grid place-items-center border border-red-500/40 bg-red-500/10 rounded-sm">
            <Radar className="h-4 w-4 text-red-500" />
          </div>
          <div>
            <div className="data-label">CLASSIFIED · INTERNAL</div>
            <h1 className="font-heading text-xl text-white leading-tight">
              İran Savaşı Araştırma Sitesi
            </h1>
          </div>
        </div>
        <p className="text-sm text-gray-400 leading-relaxed mb-6">
          11 ülkenin dışişleri açıklamalarının 15 Şubat - 15 Mart 2026 dönemi analizi.
          Devam etmek için erişim şifrenizi giriniz.
        </p>
        <form onSubmit={submit} className="space-y-4" data-testid="login-form">
          <div>
            <Label htmlFor="pw" className="data-label">Erişim Şifresi</Label>
            <div className="relative mt-1.5">
              <Lock className="absolute left-2.5 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500" />
              <Input
                id="pw"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="pl-9 rounded-sm bg-black/40 border-white/15 text-white font-mono focus-visible:ring-red-500/30"
                data-testid="login-password-input"
                autoFocus
              />
            </div>
          </div>
          <Button
            type="submit"
            disabled={loading || !password}
            className="w-full rounded-sm bg-red-500/90 hover:bg-red-500 text-white font-heading uppercase tracking-[0.18em] text-xs"
            data-testid="login-submit-btn"
          >
            {loading ? "Doğrulanıyor..." : "Giriş Yap"}
          </Button>
        </form>
        <div className="mt-6 text-[10px] font-mono text-gray-500 uppercase tracking-[0.18em]">
          v2.1 · Araştırma Dönemi: 15 Şubat - 15 Mart 2026
        </div>
      </Card>
    </div>
  );
}
